import * as angular from "angular";

export class DashboardService {
    private readonly root: string;
    private $http: any;

    constructor($http: any, __env: any, __app_type: string) {
        this.$http = $http;
        this.root =
            __app_type == "LEADER"
                ? "/v2/organisation/dashboard"
                : "/v2/dashboard";
    }

    all(data?: any): Promise<object> {
        return this.$http.get(this.root + "/all", data);
    }

    user(data?: any): Promise<object> {
        return this.$http.get(this.root + "/user", data);
    }

    group(data?: any): Promise<object> {
        return this.$http.get(this.root + "/group", data);
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.root, data);
    }

    update(id: string, data: any): Promise<object> {
        return this.$http.post(this.root + "/" + id, data);
    }

    duplicate(id: string, data: any): Promise<object> {
        return this.$http.post(this.root + "/duplicate/" + id, data);
    }

    delete(id: string | number): Promise<object> {
        return this.$http.delete(this.root + "/" + id);
    }

    createWidget(data: any): Promise<object> {
        return this.$http.post(this.root + "/widget", data);
    }

    updateWidget(id: number | string, data: any): Promise<object> {
        return this.$http.post(this.root + "/widget/" + id, data);
    }

    saveGrid(id: string, data: any): Promise<object> {
        return this.$http.post(this.root + "/" + id + "/saveGrid", data);
    }
}

angular.module("vcServices").service("DashboardService", DashboardService);
